import React, { Component } from 'react';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      num: this.props.num,
      height: 'auto',
      show: true,
    };

    this.action = this.action.bind(this);
  }

  action() {
    this.setState({ show: !this.state.show });
  }

  componentDidMount() {
    var that = this;

    if (process.browser) {
      if (document.readyState === 'complete') {
        const height = that.divElement.clientHeight;

        that.setState({ height: height, show: false });
      } else {
        window.addEventListener('load', function () {
          const height = that.divElement.clientHeight;

          that.setState({ height: height, show: false });
        });
      }
    }
  }

  render() {
    return (
      <div className={'includings-container py-15 ml-10 md:ml-30 border-gray-slider border-b ' + (this.state.show ? 'show' : 'hide')}>
        <p className="includings-title relative text-black text-16 font-medium flex items-center flex-row" onClick={this.action}>
          <span className="w-full">{this.props.question}</span>
          <span className="includings-arrow"></span>
        </p>

        <div
          className="relative includings-content mt-15 transition-all overflow-hidden duration-300 ease-in-out"
          ref={divElement => {
            this.divElement = divElement;
          }}
          style={{ height: this.state.height }}
          onClick={this.action}
        >
          <p className="text-left text-16">{this.props.answer}</p>
          <style global jsx>{`
            .includings-container.hide .includings-content {
              height: 0 !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
            }
            .includings-container .includings-title {
              cursor: pointer;
            }
            .includings-container.show .includings-title {
              color: #670f7a;
            }
          `}</style>
        </div>
      </div>
    );
  }
}

function Includings(props) {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col items-center justify-between pt-15 includings">
        <img src="https://weprodigi.com/uploads/images/ppc/ppcIncludings1.svg" width={60} alt="ppcIncludings1" />

        <div className="w-0 border-l-2  border-green-badge h-full my-5" />
        <img src="https://weprodigi.com/uploads/images/ppc/ppcIncludings2.svg" width={60} alt="ppcIncludings2" />
      </div>
      <div>
        {props.content?.map(function (benefit, i) {
          return <Question key={i} num={i + 1} question={benefit.title} answer={benefit.answer}></Question>;
        })}
      </div>
    </div>
  );
}

export default Includings;
